"use client";
import FiltersContent from "@/app/search/facets/filtersContent";
import type { CategoryFacetType } from "@/app/search/utils/createUsableCategoryFacet";
import type { AlgoliaQuery } from "@/declarations/algoliaQuery";
import { useEffect, useState } from "react";
import styles from "./facetBar.module.scss";

export const STAR_RATING_ATTRIBUTE_NAME = "general_rating";

export default function FacetBar({
  facets,
  categoryFacets,
  categoryPageName,
  isCategoryFacetSelected,
  selectedFacets,
  searchQuery,
}: FacetBarProps) {
  const [categoryResetSignal, setCategoryResetSignal] = useState(0);
  const [selectedValues, setSelectedValues] = useState<Record<string, Record<string, boolean>>>({});

  useEffect(() => {
    if (isCategoryFacetSelected === false) {
      setCategoryResetSignal((prev) => prev + 1); // Increment to trigger reset
    }
  }, [isCategoryFacetSelected]);

  if (!facets) {
    return null;
  }

  return (
    <aside id="facets-bar" className={styles.facetsContainer}>
      <section className={styles.facetSection}>
        <FiltersContent
          filterType="default"
          categoryFacets={categoryFacets}
          facets={facets}
          categoryPageName={categoryPageName}
          categoryResetSignal={categoryResetSignal}
          setCategoryResetSignal={setCategoryResetSignal}
          setSelectedValues={setSelectedValues}
          selectedValues={selectedFacets}
          searchQuery={searchQuery}
        />
      </section>
    </aside>
  );
}

export type FacetBarProps = {
  id?: string;
  className?: string;
  facets: Record<string, Record<string, number>> | undefined;
  categoryFacets: CategoryFacetType[];
  categoryPageName?: string;
  deliveryToUser?: { city: string | undefined; zipCode: string | undefined };
  updateLocationDetails?: (() => void) | undefined;
  isCategoryFacetSelected?: boolean;
  selectedFacets: Record<string, Record<string, boolean>>;
  searchQuery: AlgoliaQuery;
};
